import { EventBus } from "./eventBus/eventBus";
import { EventBusEvent } from "./eventBus/eventBusEvent.enum";

export default function showNotification(notificationText: string, timeoutInMS = 5000) {
    EventBus.$emit(EventBusEvent.ShowNotification, { notificationText, timeout: timeoutInMS })
}